import BaseService from './baseService';

class ArtistAdminService { //14.4

    static createProfile(data) {
        return BaseService.postAndReturn('/Profiles', data, BaseService.returnAssignedObject, 'Unable to create profile', true);
    }

    static updateProfile(id, data) {
        return BaseService.putAndReturn(`/Profiles/${id}`, data, BaseService.returnAssignedObject, 'Unable to update profile', true);
    }

    static enableDisableProfile(id, enable) {
        return BaseService.putAndReturn(`/Profiles/${id}/EnableDisable?enable=${enable}`, {}, BaseService.returnAssignedObject, 'Unable to enable/disable profile', true);
    }

    static getNotifications(roleID, page) {    
        return BaseService.getAndReturn(`/Profiles/${roleID}/Notifications?page=${page}`, BaseService.returnAssignedObject, 'Unable to fetch notifications', true);
    }

    static getAssociations(roleID) {    
        return BaseService.getAndReturn(`/Profiles/${roleID}/Associations`, BaseService.returnAssignedArray, 'Unable to fetch associations', true);
    }

    static addAssociation(roleID, association) {
        return BaseService.postAndReturn(`/Profiles/${roleID}/Associations`, association, (data) => data, 'Unable to add association', true);
    }

    static deleteAssociation(roleID, associationID) {
        return BaseService.deleteAndReturn(`/Profiles/${roleID}/Associations/${associationID}`, (data) => data, 'Unable to delete association', true);
    }

    static getBio(id) {    
        return BaseService.getAndReturn(`/Profiles/${id}/BioText`, (data) => data, 'Unable to fetch bio', true);
    }

    static createBio(id, bio) {
        return BaseService.postAndReturn(`/Profiles/${id}/BioText`, bio, (data) => data, 'Unable to set bio', true);
    }

    static getImages(id) {    
        return BaseService.getAndReturn(`/Profiles/${id}/ImagesUploaded`, BaseService.returnAssignedArray, 'Unable to fetch images', true);
    }

    static uploadImage(roleID, imageData) {    
        return BaseService.postAndReturn(`/Profiles/${roleID}/ImagesUploaded`, imageData, BaseService.returnAssignedObject, 'Unable to upload image', true);
    }

    static updateImage(roleID, imageID, name, description, featured, imageData) {    
        return BaseService.putAndReturn(`/Profiles/${roleID}/ImagesUploaded/${imageID}`, { name, description, featured, image: imageData }, BaseService.returnAssignedObject, 'Unable to update image', true);
    }

    static deleteImage(roleID, imageID) {    
        return BaseService.deleteAndReturn(`/Profiles/${roleID}/ImagesUploaded/${imageID}`, (data) => data, 'Unable to delete image');
    }

    static getTracks(id) {    
        return BaseService.getAndReturn(`/Profiles/${id}/TracksUploaded`, BaseService.returnAssignedArray, 'Unable to fetch tracks', true);
    }

    static getSoundCloudTracks(soundCloudToken) {    
        return BaseService.getAndReturn(`/Profiles/SoundCloudTracks`, BaseService.returnAssignedArray, 'Unable to fetch SoundCloud tracks', true, null, {'soundCloudToken': soundCloudToken});
    }

    static uploadTrack(roleID, soundCloudToken, track) {    
        return BaseService.postAndReturn(`/Profiles/${roleID}/TracksUploaded`, track, BaseService.returnAssignedObject, 'Unable to upload track', true, null, {'soundCloudToken': soundCloudToken});
    }

    static updateTrack(roleID, trackID, name, description, featured) {    
        return BaseService.putAndReturn(`/Profiles/${roleID}/TracksUploaded/${trackID}`, { name, description, featured }, BaseService.returnAssignedObject, 'Unable to update track', true);
    }

    static deleteTrack(roleID, trackID) {    
        return BaseService.deleteAndReturn(`/Profiles/${roleID}/TracksUploaded/${trackID}`, (data) => data, 'Unable to delete track', true);
    }

    static addSoundCloudTrack(roleID, trackID) {
        return BaseService.postAndReturn(`/Profiles/${roleID}/TracksUploaded/SoundCloudTracks/${trackID}`, {}, BaseService.returnAssignedObject, 'Unable to add track', true);
    }

    static getVideos(id) {    
        return BaseService.getAndReturn(`/Profiles/${id}/VideosUploaded`, BaseService.returnAssignedArray, 'Unable to fetch videos', true);
    }

    static addVideo(roleID, video) {    
        return BaseService.postAndReturn(`/Profiles/${roleID}/VideosUploaded`, video, BaseService.returnAssignedObject, 'Unable to add video', true);
    }

    static updateVideo(roleID, videoID, video) {    
        return BaseService.putAndReturn(`/Profiles/${roleID}/VideosUploaded/${videoID}`, video, BaseService.returnAssignedObject, 'Unable to update video', true);
    }

    static deleteVideo(roleID, videoID) {    
        return BaseService.deleteAndReturn(`/Profiles/${roleID}/VideosUploaded/${videoID}`, (data) => data, 'Unable to delete video', true);
    }

    static getGigs(id) {    
        return BaseService.getAndReturn(`/Profiles/${id}/GigsUploaded`, BaseService.returnAssignedArray, 'Unable to fetch gigs', true);
    }

    static addGig(roleID, video) {    
        return BaseService.postAndReturn(`/Profiles/${roleID}/GigsUploaded`, video, BaseService.returnAssignedObject, 'Unable to add gig', true);
    }

    static updateGig(roleID, gigID, gig) {    
        return BaseService.putAndReturn(`/Profiles/${roleID}/GigsUploaded/${gigID}`, gig, BaseService.returnAssignedObject, 'Unable to update gig', true);
    }

    static deleteGig(roleID, gigID) {    
        return BaseService.deleteAndReturn(`/Profiles/${roleID}/GigsUploaded/${gigID}`, (data) => data, 'Unable to delete gig', true);
    }

    static getBuyOptions(id) {    
        return BaseService.getAndReturn(`/Profiles/${id}/BuyOptionsUploaded`, BaseService.returnAssignedArray, 'Unable to fetch buy options', true);
    }

    static addBuyOption(roleID, buyOption) {    
        return BaseService.postAndReturn(`/Profiles/${roleID}/BuyOptionsUploaded`, buyOption, BaseService.returnAssignedArray, 'Unable to add buy option', true);
    }

    static deleteBuyOption(roleID, buyOptionID) {    
        return BaseService.deleteAndReturn(`/Profiles/${roleID}/BuyOptionsUploaded/${buyOptionID}`, (data) => data, 'Unable to delete buy option', true);
    }

    static getAddress(roleID) {    
        return BaseService.getAndReturn(`/Profiles/${roleID}/AddressUploaded`, BaseService.returnAssignedObject, 'Unable to fetch address', true);
    }

    static updateAddress(roleID, address) {    
        return BaseService.putAndReturn(`/Profiles/${roleID}/AddressUploaded`, address, BaseService.returnAssignedObject, 'Unable to update address', true);
    }

    static getChatSettings(roleID) {    
        return BaseService.getAndReturn(`/Profiles/${roleID}/ChatSettings`, BaseService.returnAssignedObject, 'Unable to fetch chat settings', true);
    }

    static updateChatSettings(roleID, chatSettings) {    
        return BaseService.putAndReturn(`/Profiles/${roleID}/ChatSettings`, chatSettings, BaseService.returnAssignedObject, 'Unable to update chat settings', true);
    }

    static getMessages(roleID, sentReceived) {    
        return BaseService.getAndReturn(`/Profiles/${roleID}/Messages/${sentReceived}`, BaseService.returnAssignedArray, 'Unable to fetch messages', true);
    }

    static getConversation(roleID, conversationID) {    
        return BaseService.getAndReturn(`/Profiles/${roleID}/Messages/${conversationID}`, BaseService.returnAssignedArray, 'Unable to fetch conversation', true);
    }

    static deleteConversation(roleID, conversationID) {    
        return BaseService.deleteAndReturn(`/Profiles/${roleID}/Messages/${conversationID}`, (data) => data, 'Unable to delete conversation', true);
    }

    static getMessageRecipients(roleID, searchString) {
        return BaseService.getAndReturn(`/Profiles/${roleID}/Messages/Recipients/${searchString}`, BaseService.returnAssignedArray, 'Unable to fetch recipients', true);
    }

    static sendMessage(roleID, message) {    
        return BaseService.postAndReturn(`/Profiles/${roleID}/Messages`, message, BaseService.returnAssignedObject, 'Unable to send message', true);
    }

}
export default ArtistAdminService;